import React, { useEffect } from "react";
import "../../../assets/css/custom.css";
import UserListHeader from "./userListHeader";
import UserListTab from "./userListTab";
import { useParams, useNavigate } from "react-router-dom";

export default function UserList() {
  const params = useParams();
  const nav = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      nav("/login");
      return;
    }
    // La liste des Distributeurs (/userList/2) est réservée à l'Admin (role_id = 1)
    const loggedRoleId = localStorage.getItem("user_role_id");
    if (params.id === "2" && loggedRoleId !== "1") {
      nav("/Dashboard");
    }
    // eslint-disable-next-line
  }, [params.id]);

  return (
    <>
      <div className="main-box">
        {/* <Sidebar /> */}
        <div className="content-wrapper-custom">
          <UserListHeader role_id={params.id} />
          <UserListTab role_id={params.id} />
        </div>
      </div>
    </>
  );
}
